import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { useOktaAuth } from '@okta/okta-react';

interface Props {
  isOpen: boolean;
}
export default function NotificationDialog(props: Props) {
  const [modal, setModal] = useState(false);
  const { oktaAuth } = useOktaAuth();

  const handleOk = async () => {
    setModal(false);
    try {
      oktaAuth.tokenManager.clear();
      await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + '/amplify-portal-client/' });
    } catch (e) {
      console.error('Error during sign out:', e);
      window.location.href = window.location.origin + '/amplify-portal-client/';
    }
  };

  useEffect(() => {
    if (props.isOpen) setModal(true);
  }, [props.isOpen]);
  return (
    <Modal isOpen={modal}>
      <ModalBody>
        User has no permissions assigned. Please contact your app administrator, or the Help Desk at (901)578-2222.
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={handleOk}>
          Ok
        </Button>
      </ModalFooter>
    </Modal>
  );
}
